import React from 'react';
import { Box } from '@zillow/constellation-10';

// Styles
import { containerStyles, dotRecipe } from './styles';

// Types
type DotsPropTypes = {
  index: number;
  count: number;
  onGoToItem: (index: number) => void;
};

const Dots = ({ index, count, onGoToItem }: DotsPropTypes) => {
  const dots = [];
  for (let i = 0; i < count; i++) {
    dots.push(
      <Box key={i} asChild css={dotRecipe.raw({ isActive: i === index })}>
        <button
          type="button"
          aria-label={`Go to slide ${i + 1}`}
          aria-current={i === index}
          onClick={() => onGoToItem(i)}
        />
      </Box>,
    );
  }

  return <Box css={containerStyles}>{dots}</Box>;
};

export default Dots;
